<template>
 <section id="footer" v-if="isLogin">
      <footer id="sticky-footer" class="flex-shrink-0 py-4 navbar-background text-white-50">
        <div class="container text-center">
          <div>
            <p>Hacktiv8 Batch 17 Quimper Fox</p>
          </div>
          <div>
            <p>Vaxin8 Team</p>
          </div>
        </div>
      </footer>
    </section>
</template>

<script>
export default {
    name : 'Footer',
    computed : {
      isLogin(){
        return this.$store.state.isLogin
      }
    }
}
</script>

<style>

</style>